import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54d2432c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center justify-center fill-height" }
const _hoisted_2 = { class: "mt-3 mb-3" }
const _hoisted_3 = { class: "mt-2 mb-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.famulatur-ranking.de/",
    target: "_blank"
  }, " Famulatur Ranking")
], -1))
const _hoisted_5 = {
  style: {"width":"80%"},
  align: "start"
}
const _hoisted_6 = {
  class: "mt-4",
  style: {"font-size":"large","font-weight":"500"}
}
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = {
  style: {"color":"black"},
  href: "tel:'`${phoneNumber}`"
}
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = { style: {"height":"200px"} }
const _hoisted_16 = { class: "mt-2" }
const _hoisted_17 = { class: "mb-2" }

import { useI18n } from "vue-i18n"
import { computed, onMounted, onUnmounted, ref } from "vue"
import { Hospital } from "@/types"
import "leaflet/dist/leaflet.css"
import { LMap, LTileLayer } from "@vue-leaflet/vue-leaflet"
import {
  departmentValueToEnMap,
  departmentValueToDeMap,
} from "@/types/hospital-spec"
const zoom = 10

export default /*#__PURE__*/_defineComponent({
  __name: 'HospitalPersonalInfo',
  props: {
    hospital: {}
  },
  setup(__props: any) {

const { t } = useI18n()
const props = __props
const hospital = ref<Hospital | undefined>(props.hospital)
const rating = ref(4)
const locale = ref<string>(localStorage.getItem("locale") ?? "de")
const key = ref(0)

onMounted(() => {
  window.addEventListener("locale-changed", loadPage)
})
onUnmounted(() => {
  window.removeEventListener("locale-changed", loadPage)
})

const loadPage = () => {
  locale.value = localStorage.getItem("locale") ?? "de"
  key.value++
}

const hospitalDepartments = computed((): string[] => {
  var departments: string[] = []
  hospital.value?.doctors.forEach((doctor) => {
    departments.push(doctor.department)
  })
  return departments
})

const address = computed((): string => {
  return `${hospital.value?.hospitalStreet}, ${hospital.value?.hospitalLocation}, ${hospital.value?.hospitalZip},  ${hospital.value?.hospitalState},  ${hospital.value?.hospitalLand}  `
})
const latitude = computed((): number => {
  return hospital.value?.location.coordinates[0] ?? 48.1351
})
const longitude = computed((): number => {
  return hospital.value?.location.coordinates[1] ?? 11.582
})

const phoneNumber = computed((): string => {
  return `${hospital.value?.phoneNo ?? "-"}`
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_rating = _resolveComponent("v-rating")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", { key: key.value }, [
    _createVNode(_component_v_card, {
      class: "ml-2",
      height: "820",
      levation: "5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_img, _mergeProps(props, {
          class: "mt-2",
          width: 133,
          style: {"border-radius":"50%"},
          cover: "",
          src: 
          hospital.value?.photo != '' && hospital.value?.photo != undefined
            ? hospital.value?.photo
            : require('../../../../assets/hospital.png')
        
        }), {
          placeholder: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_progress_circular, {
                color: "#3fb984",
                indeterminate: ""
              })
            ])
          ]),
          _: 1
        }, 16, ["src"]),
        _createElementVNode("h3", _hoisted_2, _toDisplayString(hospital.value?.name), 1),
        _createVNode(_component_v_divider, { style: {"width":"80%"} }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_row, {
            align: "center",
            justify: "space-evenly"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_rating, {
                class: "ml-2 mr-2",
                modelValue: rating.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rating).value = $event)),
                "active-color": "blue",
                color: "orange-lighten-1",
                readonly: ""
              }, null, 8, ["modelValue"]),
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_divider, { style: {"width":"80%"} }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("contact")), 1),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("email")) + ":", 1),
            _createElementVNode("h4", _hoisted_8, [
              _createElementVNode("a", {
                style: {"color":"black"},
                href: 'mailto:' + hospital.value?.email
              }, _toDisplayString(hospital.value?.email), 9, _hoisted_9)
            ])
          ]),
          _createVNode(_component_v_divider),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("phoneNumber")) + ":", 1),
          _createElementVNode("h4", _hoisted_11, [
            _createElementVNode("a", _hoisted_12, _toDisplayString(phoneNumber.value), 1)
          ]),
          _createVNode(_component_v_divider),
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("address")) + ":", 1),
          _createElementVNode("h4", _hoisted_14, _toDisplayString(address.value), 1),
          _createVNode(_component_v_divider),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(LMap), {
              ref: "map",
              zoom: zoom,
              "onUpdate:zoom": _cache[1] || (_cache[1] = ($event: any) => ((zoom) = $event)),
              center: [longitude.value, latitude.value]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(LTileLayer), {
                  url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                  "layer-type": "base",
                  name: "OpenStreetMap"
                })
              ]),
              _: 1
            }, 8, ["center"])
          ]),
          _createVNode(_component_v_divider),
          _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("hospital.departments")), 1),
          _createElementVNode("h4", _hoisted_17, [
            _createVNode(_component_v_chip_group, {
              column: "",
              style: {"pointer-events":"none"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hospitalDepartments.value, (department, i) => {
                  return (_openBlock(), _createBlock(_component_v_chip, { key: i }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(locale.value == "de"
                ? _unref(departmentValueToDeMap)[department]
                : _unref(departmentValueToEnMap)[department]), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})